import type { EmotionalState, Diagnosis, Baseline } from '@alphahub/eie-core';
import type { PoseSnapshot } from '../WebPoseDetector';

export interface PendingLocalCalibration {
  screenAnchor?: { x: number; y: number };
  calibrationReadyAt?: number;
}

/**
 * SessionStateStore owns all mutable session state that is shared across
 * EIESession and its delegated services. Pure data container — no logic.
 */
export class SessionStateStore {
  timeline: EmotionalState[] = [];
  diagnoses: Diagnosis[] = [];
  baseline?: Baseline;
  poseSnapshots: PoseSnapshot[] = [];
  latestHeartRate?: { bpm: number; confidence: number; signalQuality: string };

  pendingMilestoneChunkId?: number;
  pendingRequests: number = 0;

  handNearFaceBuffer: boolean[] = [];
  cognitiveStateBuffer: string[] = [];
  emotionBuffer: Array<{ emotion: string; confidence: number; timestamp: number }> = [];
  lastStableEmotion: string | null = null;

  pendingLocalCalibration: PendingLocalCalibration | null = null;

  reset(): void {
    this.timeline = [];
    this.diagnoses = [];
    this.baseline = undefined;
    this.poseSnapshots = [];
    this.latestHeartRate = undefined;
    this.pendingMilestoneChunkId = undefined;
    this.pendingLocalCalibration = null;
  }
}
